import React from "react"
import { PlainLink, TextProps } from "components/text"

export const PHONE_NUMBER = "(877) 456-2683"
export const EMAIL = "care@withcove.com"

export const SupportPhoneLink = (props: TextProps) => (
  <PlainLink {...props} href={`tel:${PHONE_NUMBER}`}>
    {PHONE_NUMBER}
  </PlainLink>
)

export const SupportEmailLink = (props: TextProps) => (
  <PlainLink {...props} href={`mailto:${EMAIL}`}>
    {EMAIL}
  </PlainLink>
)
